import React, { Fragment } from 'react';

import { Container, Layout, BackTop } from '@/elements';

import './index.scss';

const { Sider, Content } = Layout;

export const Sidebar = ({ children }) => <Fragment>{children}</Fragment>;

export const Main = ({ children }) => <Fragment>{children}</Fragment>;

const PageContent = ({ children, className }) => (
	<Container className={`${className} page-content-layout`} tag={Layout}>
		{React.Children.map(children, child => {
			if (!child) {
				return child;
			}
			if (child.type === Sidebar) {
				return (
					<Sider
						className="page-sidebar"
						collapsedWidth="0"
						breakpoint="md"
					>
						{child}
					</Sider>
				);
			}

			return <Content>{child}</Content>;
		})}
    <BackTop />
	</Container>
);

PageContent.Main = Main;
PageContent.Sidebar = Sidebar;

export default PageContent;



// WEBPACK FOOTER //
// ./src/components/page-content/index.js